import React, { useState } from "react";
import "./Panel.css";
import { getSession, setSession } from "./api";
import Login from "./Login";
import AdminDashboard from "./AdminDashboard";
import ProviderDashboard from "./ProviderDashboard";


export default function Panel() {
  const [session, setSess] = useState(getSession());

  const onLogin = (s) => { setSession(s); setSess(s); };
  const onLogout = () => { setSession(null); setSess(null); };

  if (!session) return <Login onLogin={onLogin} />;
  return session.user.role === "admin"
    ? <AdminDashboard user={session.user} onLogout={onLogout} />
    : <ProviderDashboard user={session.user} onLogout={onLogout} />;
}